// extracted by mini-css-extract-plugin
export default {"Box":"selected-repository-pill-module__Box--qnggo","Text":"selected-repository-pill-module__Text--h0Qtm","Text_1":"selected-repository-pill-module__Text_1--CCwvU"};